// JWT 토큰 파싱 및 만료 확인 유틸리티
export const tokenUtils = {
    parseToken: (token) => {
        if (!token) return null;
        try {
            // Base64 URL 디코딩 후 UTF-8 문자열로 변환
            const base64Url = token.split('.')[1];
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            const jsonPayload = decodeURIComponent(
                atob(base64)
                    .split('')
                    .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                    .join('')
            );
            //console.log('JWT 토큰 페이로드:', JSON.parse(jsonPayload));
            return JSON.parse(jsonPayload);
        } catch (error) {
            console.error('JWT 토큰 파싱 오류:', error);
            return null;
        }
    },
    
    isTokenExpired: (token) => {
        if (!token) return true;
        const payload = tokenUtils.parseToken(token);
        if (!payload || !payload.exp) return true;
        return Date.now() >= payload.exp * 1000;
    },
    
    getTokenExpireTime: (token) => {
        const payload = tokenUtils.parseToken(token);
        return payload?.exp ? new Date(payload.exp * 1000) : null;
    },
};